import React, { useEffect, useRef } from 'react';
import { Route } from 'react-router-dom';
import {
  IonApp,
  IonContent,
  IonHeader,
  IonRouterOutlet,
  IonToolbar,
  setupIonicReact,
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import AuthWrapper from './pages/AuthWapper';
import SignIn from './pages/Authentication/SignIn';
import SignUp from './pages/Authentication/SignUp';
import ForgotPassword from './pages/Authentication/ForgotPassword';
import ResetPassword from './pages/Authentication/ResetPassword';
import '@ionic/react/css/core.css';
import './theme/variables.css';
import ErrorPage from './pages/ErrorPage';
import DashboardLayout from './pages/Dashboard/Layout';
import useAxiosInterceptor from './hooks/useAxiosInterceptor';
import MainNavBar from './components/navbar/MainNavBar';
import { DialogProvider } from './context/Dialog';
import GoogleAuth from './pages/Authentication/GoogleAuth';
import { useDispatch } from 'react-redux';
import { setIsNative } from './store/slices/settings/slice';
import { Capacitor } from '@capacitor/core';
setupIonicReact();

const App: React.FC = () => {
  useAxiosInterceptor();
  const mainContainer = useRef<HTMLIonContentElement>(null);
  const dispatch = useDispatch();
  const isNative = Capacitor.isNativePlatform();

  useEffect(() => {
    dispatch(setIsNative(isNative));
  }, [isNative]);

  return (
    <>
      <IonApp className="fixed w-full h-full">
        <IonReactRouter>
          {isNative ? (
            <IonHeader className="w-full">
              <IonToolbar className="w-full h-full p-0 " color="secondary">
                <MainNavBar />
              </IonToolbar>
            </IonHeader>
          ) : (
            <MainNavBar />
          )}
          <IonContent ref={mainContainer}>
            <DialogProvider>
              <IonRouterOutlet>
                {/* SIGNIN AUTHENTICATION ROUTE */}
                <Route exact path="/auth/sign-in">
                  <AuthWrapper>
                    <SignIn />
                  </AuthWrapper>
                </Route>

                {/* SIGNUP AUTHENTICATION ROUTE */}
                <Route exact path="/auth/sign-up">
                  <SignUp />
                </Route>

                {/* FORGOT PASSWORD ROUTES */}
                <Route exact path="/auth/forgot-password">
                  <AuthWrapper>
                    <ForgotPassword />
                  </AuthWrapper>
                </Route>

                {/* PASSWORD RESET ROUTE */}
                <Route exact path="/auth/reset-password">
                  <AuthWrapper>
                    <ResetPassword />
                  </AuthWrapper>
                </Route>

                {/* <Redirect exact from="/" to="/dashboard" /> */}
                <Route exact path="/">
                  <GoogleAuth />
                </Route>

                {/* DASHBOARD LAYOUT ROUTE */}
                <Route path="/dashboard/">
                  <AuthWrapper>
                    <DashboardLayout />
                  </AuthWrapper>
                </Route>

                {/* Fallback route for 404 errors */}
                <Route render={() => <ErrorPage />} />
              </IonRouterOutlet>
            </DialogProvider>
          </IonContent>
        </IonReactRouter>
      </IonApp>
    </>
  );
};

export default App;
